import clsx from "clsx";

import { Chip } from "@chef/components";
import { isEqualStrings } from "@chef/utils/equal";
import { useFlag } from "@chef/feature-flags";
import { FEATURE_FLAGS, FILTER_CATEGORIES } from "@chef/constants";

type FilterChipsProps = {
  selectedClassName?: string;
  className?: string;
  values: string[];
  handleClick: (value: string) => void;
  highlight?: boolean;
  alwaysShowCount?: boolean;
  chipIcon?: "check" | "cross" | "none";
  items: {
    value: string;
    label: string;
    count: number;
    type: "default" | "highlighted" | "secondary";
    isAll: boolean;
  }[];
};

export const FilterChips = ({
  selectedClassName,
  className,
  items,
  highlight = true,
  values,
  alwaysShowCount,
  chipIcon = "check",
  handleClick,
}: FilterChipsProps) => {
  const { enabled: isPrioritiseRecommendationsEnabled } = useFlag(
    FEATURE_FLAGS.PRIORITISE_RECOMMENDATIONS_FILTER,
  );

  return items.map((item) => {
    const isHighlighted = isEqualStrings(item.type, "highlighted");
    const isRecommendationsChip = isEqualStrings(
      String(item.value),
      FILTER_CATEGORIES.RECOMMENDATIONS_SLUG,
    );

    const shouldHighlightDefault = highlight && isHighlighted;
    const shouldHighlightRecommendationChip =
      !!isPrioritiseRecommendationsEnabled && isRecommendationsChip;

    const shouldHighlight =
      shouldHighlightDefault || shouldHighlightRecommendationChip;

    const isSelected = values.some((v) =>
      isEqualStrings(v, item.value.toString()),
    );

    return (
      <li key={item.value} className={className}>
        <Chip
          onClick={() => handleClick(item.value)}
          selected={isSelected}
          chipIcon={chipIcon}
          highlighted={shouldHighlight}
          className={clsx("tabular-nums", isSelected && selectedClassName)}
          id={item.value.toString()}
        >
          <span>{item.label}</span>
          {(!isSelected || item.isAll || alwaysShowCount) && (
            <span className="ml-2">({item.count})</span>
          )}
        </Chip>
      </li>
    );
  });
};
